export enum VisitorIntelProviderEnum {
    FIVE_BY_FIVE = 'FIVE_BY_FIVE',
    BOMBORA = 'BOMBORA',
}
